<button [disabled]="disabled()" appTooltip="Snap To Features" class="esk-tool" [ngClass]="{'esk-tool--active' : active()===true}" (click)="toggleTool()"><i class="fa fa-magnet"></i></button>
